var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-checkbox',{model:{value:(_vm.showAxiomAnnots),callback:function ($$v) {_vm.showAxiomAnnots=$$v},expression:"showAxiomAnnots"}},[_vm._v("Include Axiom Annotations")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3531da04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settingsViews/descriptionSettingsView.vue
// module id = f0ln
// module chunks = 1